import { render, staticRenderFns } from "./AccountSettingManageZoom.vue?vue&type=template&id=4bfe49f6&"
import script from "./AccountSettingManageZoom.vue?vue&type=script&lang=js&"
export * from "./AccountSettingManageZoom.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingManageZoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports